var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 53,
    viewBox: "0 0 66 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85402 49.9042C6.36602 49.9042 5.92202 49.8202 5.52202 49.6522C5.13002 49.4762 4.79002 49.2362 4.50202 48.9322C4.21402 48.6282 3.99002 48.2802 3.83002 47.8882C3.67802 47.4962 3.60202 47.0802 3.60202 46.6402C3.60202 46.0482 3.73402 45.5082 3.99802 45.0202C4.27002 44.5322 4.64602 44.1402 5.12602 43.8442C5.61402 43.5482 6.19002 43.4002 6.85402 43.4002C7.49402 43.4002 8.05002 43.5442 8.52202 43.8322C9.00202 44.1122 9.35402 44.4882 9.57802 44.9602L8.29402 45.3682C8.15002 45.1042 7.94602 44.9002 7.68202 44.7562C7.42602 44.6042 7.14202 44.5282 6.83002 44.5282C6.47802 44.5282 6.15802 44.6202 5.87002 44.8042C5.59002 44.9802 5.36602 45.2282 5.19802 45.5482C5.03802 45.8602 4.95802 46.2242 4.95802 46.6402C4.95802 47.0402 5.04202 47.4042 5.21002 47.7322C5.37802 48.0522 5.60202 48.3082 5.88202 48.5002C6.17002 48.6842 6.49002 48.7762 6.84202 48.7762C7.05802 48.7762 7.26602 48.7402 7.46602 48.6682C7.67402 48.5882 7.85402 48.4842 8.00602 48.3562C8.15802 48.2202 8.26602 48.0722 8.33002 47.9122L9.62602 48.2962C9.49002 48.6082 9.28602 48.8842 9.01402 49.1242C8.75002 49.3642 8.43402 49.5562 8.06602 49.7002C7.70602 49.8362 7.30202 49.9042 6.85402 49.9042ZM13.4746 49.9042C12.9786 49.9042 12.5346 49.8202 12.1426 49.6522C11.7506 49.4762 11.4106 49.2362 11.1226 48.9322C10.8426 48.6282 10.6266 48.2842 10.4746 47.9002C10.3226 47.5082 10.2466 47.0922 10.2466 46.6522C10.2466 46.2122 10.3226 45.7962 10.4746 45.4042C10.6266 45.0122 10.8426 44.6682 11.1226 44.3722C11.4106 44.0682 11.7506 43.8322 12.1426 43.6642C12.5426 43.4882 12.9866 43.4002 13.4746 43.4002C13.9626 43.4002 14.4026 43.4882 14.7946 43.6642C15.1946 43.8322 15.5346 44.0682 15.8146 44.3722C16.1026 44.6682 16.3226 45.0122 16.4746 45.4042C16.6266 45.7962 16.7026 46.2122 16.7026 46.6522C16.7026 47.0922 16.6266 47.5082 16.4746 47.9002C16.3226 48.2842 16.1026 48.6282 15.8146 48.9322C15.5346 49.2362 15.1946 49.4762 14.7946 49.6522C14.4026 49.8202 13.9626 49.9042 13.4746 49.9042ZM11.6026 46.6642C11.6026 47.0642 11.6866 47.4242 11.8546 47.7442C12.0226 48.0642 12.2466 48.3162 12.5266 48.5002C12.8066 48.6842 13.1226 48.7762 13.4746 48.7762C13.8186 48.7762 14.1306 48.6842 14.4106 48.5002C14.6986 48.3082 14.9266 48.0522 15.0946 47.7322C15.2626 47.4042 15.3466 47.0442 15.3466 46.6522C15.3466 46.2522 15.2626 45.8922 15.0946 45.5722C14.9266 45.2522 14.6986 45.0002 14.4106 44.8162C14.1306 44.6242 13.8186 44.5282 13.4746 44.5282C13.1226 44.5282 12.8066 44.6242 12.5266 44.8162C12.2466 45.0082 12.0226 45.2642 11.8546 45.5842C11.6866 45.8962 11.6026 46.2562 11.6026 46.6642ZM27.4733 49.7842H26.1533V46.2682C26.1533 45.6842 26.0573 45.2562 25.8653 44.9842C25.6733 44.7122 25.3933 44.5762 25.0253 44.5762C24.6573 44.5762 24.3133 44.7162 23.9933 44.9962C23.6813 45.2682 23.4613 45.6242 23.3333 46.0642V49.7842H22.0133V46.2682C22.0133 45.6842 21.9173 45.2562 21.7253 44.9842C21.5333 44.7122 21.2573 44.5762 20.8973 44.5762C20.5293 44.5762 20.1853 44.7122 19.8653 44.9842C19.5533 45.2562 19.3293 45.6122 19.1933 46.0522V49.7842H17.8733V43.5082H19.0733V44.7682C19.3213 44.3282 19.6453 43.9922 20.0453 43.7602C20.4533 43.5202 20.9173 43.4002 21.4373 43.4002C21.9573 43.4002 22.3653 43.5362 22.6613 43.8082C22.9653 44.0802 23.1533 44.4202 23.2253 44.8282C23.4973 44.3642 23.8293 44.0122 24.2213 43.7722C24.6213 43.5242 25.0773 43.4002 25.5893 43.4002C25.9573 43.4002 26.2653 43.4682 26.5133 43.6042C26.7613 43.7402 26.9533 43.9282 27.0893 44.1682C27.2253 44.4002 27.3213 44.6722 27.3773 44.9842C27.4413 45.2882 27.4733 45.6122 27.4733 45.9562V49.7842Z",
    fill: "#5C595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5584 49.9042C32.0544 49.9042 31.6104 49.7842 31.2264 49.5442C30.8424 49.3042 30.5384 48.9922 30.3144 48.6082V52.3402H28.9944V43.5082H30.1584V44.6362C30.3984 44.2602 30.7104 43.9602 31.0944 43.7362C31.4784 43.5122 31.9064 43.4002 32.3784 43.4002C32.8104 43.4002 33.2064 43.4882 33.5664 43.6642C33.9264 43.8322 34.2384 44.0682 34.5024 44.3722C34.7664 44.6762 34.9704 45.0242 35.1144 45.4162C35.2664 45.8002 35.3424 46.2082 35.3424 46.6402C35.3424 47.2402 35.2224 47.7882 34.9824 48.2842C34.7504 48.7802 34.4224 49.1762 33.9984 49.4722C33.5824 49.7602 33.1024 49.9042 32.5584 49.9042ZM32.1264 48.7762C32.4064 48.7762 32.6584 48.7162 32.8824 48.5962C33.1144 48.4762 33.3104 48.3162 33.4704 48.1162C33.6384 47.9162 33.7664 47.6882 33.8544 47.4322C33.9424 47.1762 33.9864 46.9122 33.9864 46.6402C33.9864 46.3522 33.9384 46.0802 33.8424 45.8242C33.7464 45.5682 33.6064 45.3442 33.4224 45.1522C33.2464 44.9602 33.0384 44.8082 32.7984 44.6962C32.5664 44.5842 32.3104 44.5282 32.0304 44.5282C31.8624 44.5282 31.6864 44.5602 31.5024 44.6242C31.3184 44.6882 31.1464 44.7762 30.9864 44.8882C30.8264 45.0002 30.6864 45.1322 30.5664 45.2842C30.4464 45.4362 30.3624 45.5962 30.3144 45.7642V47.4082C30.4264 47.6642 30.5744 47.8962 30.7584 48.1042C30.9424 48.3042 31.1544 48.4682 31.3944 48.5962C31.6344 48.7162 31.8784 48.7762 32.1264 48.7762ZM40.0576 44.6482C39.5456 44.6562 39.0896 44.7722 38.6896 44.9962C38.2976 45.2202 38.0176 45.5362 37.8496 45.9442V49.7842H36.5296V43.5082H37.7536V44.9122C37.9696 44.4802 38.2536 44.1362 38.6056 43.8802C38.9576 43.6162 39.3296 43.4722 39.7216 43.4482C39.8016 43.4482 39.8656 43.4482 39.9136 43.4482C39.9696 43.4482 40.0176 43.4522 40.0576 43.4602V44.6482ZM43.7206 49.9042C43.2246 49.9042 42.7806 49.8202 42.3886 49.6522C41.9966 49.4762 41.6566 49.2362 41.3686 48.9322C41.0886 48.6282 40.8726 48.2842 40.7206 47.9002C40.5686 47.5082 40.4926 47.0922 40.4926 46.6522C40.4926 46.2122 40.5686 45.7962 40.7206 45.4042C40.8726 45.0122 41.0886 44.6682 41.3686 44.3722C41.6566 44.0682 41.9966 43.8322 42.3886 43.6642C42.7886 43.4882 43.2326 43.4002 43.7206 43.4002C44.2086 43.4002 44.6486 43.4882 45.0406 43.6642C45.4406 43.8322 45.7806 44.0682 46.0606 44.3722C46.3486 44.6682 46.5686 45.0122 46.7206 45.4042C46.8726 45.7962 46.9486 46.2122 46.9486 46.6522C46.9486 47.0922 46.8726 47.5082 46.7206 47.9002C46.5686 48.2842 46.3486 48.6282 46.0606 48.9322C45.7806 49.2362 45.4406 49.4762 45.0406 49.6522C44.6486 49.8202 44.2086 49.9042 43.7206 49.9042ZM41.8486 46.6642C41.8486 47.0642 41.9326 47.4242 42.1006 47.7442C42.2686 48.0642 42.4926 48.3162 42.7726 48.5002C43.0526 48.6842 43.3686 48.7762 43.7206 48.7762C44.0646 48.7762 44.3766 48.6842 44.6566 48.5002C44.9446 48.3082 45.1726 48.0522 45.3406 47.7322C45.5086 47.4042 45.5926 47.0442 45.5926 46.6522C45.5926 46.2522 45.5086 45.8922 45.3406 45.5722C45.1726 45.2522 44.9446 45.0002 44.6566 44.8162C44.3766 44.6242 44.0646 44.5282 43.7206 44.5282C43.3686 44.5282 43.0526 44.6242 42.7726 44.8162C42.4926 45.0082 42.2686 45.2642 42.1006 45.5842C41.9326 45.8962 41.8486 46.2562 41.8486 46.6642ZM51.6834 49.9042C51.1794 49.9042 50.7354 49.7842 50.3514 49.5442C49.9674 49.3042 49.6634 48.9922 49.4394 48.6082V52.3402H48.1194V43.5082H49.2834V44.6362C49.5234 44.2602 49.8354 43.9602 50.2194 43.7362C50.6034 43.5122 51.0314 43.4002 51.5034 43.4002C51.9354 43.4002 52.3314 43.4882 52.6914 43.6642C53.0514 43.8322 53.3634 44.0682 53.6274 44.3722C53.8914 44.6762 54.0954 45.0242 54.2394 45.4162C54.3914 45.8002 54.4674 46.2082 54.4674 46.6402C54.4674 47.2402 54.3474 47.7882 54.1074 48.2842C53.8754 48.7802 53.5474 49.1762 53.1234 49.4722C52.7074 49.7602 52.2274 49.9042 51.6834 49.9042ZM51.2514 48.7762C51.5314 48.7762 51.7834 48.7162 52.0074 48.5962C52.2394 48.4762 52.4354 48.3162 52.5954 48.1162C52.7634 47.9162 52.8914 47.6882 52.9794 47.4322C53.0674 47.1762 53.1114 46.9122 53.1114 46.6402C53.1114 46.3522 53.0634 46.0802 52.9674 45.8242C52.8714 45.5682 52.7314 45.3442 52.5474 45.1522C52.3714 44.9602 52.1634 44.8082 51.9234 44.6962C51.6914 44.5842 51.4354 44.5282 51.1554 44.5282C50.9874 44.5282 50.8114 44.5602 50.6274 44.6242C50.4434 44.6882 50.2714 44.7762 50.1114 44.8882C49.9514 45.0002 49.8114 45.1322 49.6914 45.2842C49.5714 45.4362 49.4874 45.5962 49.4394 45.7642V47.4082C49.5514 47.6642 49.6994 47.8962 49.8834 48.1042C50.0674 48.3042 50.2794 48.4682 50.5194 48.5962C50.7594 48.7162 51.0034 48.7762 51.2514 48.7762ZM57.8866 49.9042C57.3586 49.9042 56.8586 49.8202 56.3866 49.6522C55.9146 49.4762 55.5106 49.2162 55.1746 48.8722L55.6666 47.9842C56.0266 48.3042 56.3866 48.5362 56.7466 48.6802C57.1146 48.8242 57.4786 48.8962 57.8386 48.8962C58.2066 48.8962 58.5066 48.8282 58.7386 48.6922C58.9706 48.5482 59.0866 48.3402 59.0866 48.0682C59.0866 47.8682 59.0266 47.7202 58.9066 47.6242C58.7866 47.5282 58.6106 47.4442 58.3786 47.3722C58.1546 47.3002 57.8826 47.2202 57.5626 47.1322C57.1146 46.9962 56.7386 46.8562 56.4346 46.7122C56.1306 46.5602 55.9026 46.3762 55.7506 46.1602C55.5986 45.9442 55.5226 45.6682 55.5226 45.3322C55.5226 44.9242 55.6266 44.5762 55.8346 44.2882C56.0426 44.0002 56.3306 43.7802 56.6986 43.6282C57.0746 43.4762 57.5066 43.4002 57.9946 43.4002C58.4506 43.4002 58.8706 43.4722 59.2546 43.6162C59.6466 43.7522 59.9906 43.9682 60.2866 44.2642L59.7226 45.1402C59.4426 44.8842 59.1546 44.6962 58.8586 44.5762C58.5706 44.4562 58.2586 44.3962 57.9226 44.3962C57.7306 44.3962 57.5466 44.4202 57.3706 44.4682C57.1946 44.5082 57.0466 44.5882 56.9266 44.7082C56.8146 44.8202 56.7586 44.9802 56.7586 45.1882C56.7586 45.3562 56.8066 45.4922 56.9026 45.5962C56.9986 45.7002 57.1426 45.7882 57.3346 45.8602C57.5266 45.9322 57.7626 46.0122 58.0426 46.1002C58.5306 46.2442 58.9466 46.3882 59.2906 46.5322C59.6346 46.6682 59.8986 46.8482 60.0826 47.0722C60.2746 47.2882 60.3706 47.5882 60.3706 47.9722C60.3706 48.5802 60.1426 49.0562 59.6866 49.4002C59.2386 49.7362 58.6386 49.9042 57.8866 49.9042Z",
    fill: "#2898FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6326 0.4375C29.6326 0.4375 9.94443 9.38023 9.94443 9.6886C9.94443 9.99697 9.84375 15.7128 9.84375 15.7128L21.4665 12.6512L29.6326 14.9089V0.4375Z",
    fill: "url(#paint0_linear_122_2053)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8807 15.1182C21.9814 15.4265 21.8807 23.8406 21.8807 23.8406L0.100678 28.7635L0 20.7019L21.8807 15.1182Z",
    fill: "url(#paint1_linear_122_2053)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5326 27.3978C34.6333 27.6952 34.5326 36.1313 34.5326 36.1313L9.6875 34.5454V27.9375L34.5326 27.3978Z",
    fill: "url(#paint2_linear_122_2053)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6328 0.4375L53.6054 15.5036L53.6389 21.2305L29.6328 14.8979V0.4375Z",
    fill: "url(#paint3_linear_122_2053)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9546 23.2679C50.9546 23.4331 51.1112 27.508 51.1112 27.508L21.9258 23.8406V15.1182L50.9546 23.2679Z",
    fill: "url(#paint4_linear_122_2053)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5322 27.3978L56.9051 30.5036C56.9051 30.5036 57.2295 36.0762 57.0729 36.0102C56.9163 35.9441 34.5882 36.1093 34.5882 36.1093L34.5322 27.3978Z",
    fill: "url(#paint5_linear_122_2053)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_2053",
    x1: 7.43867,
    y1: 8.06966,
    x2: 28.9502,
    y2: 8.06966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_122_2053",
    x1: 0,
    y1: 21.9353,
    x2: 21.9478,
    y2: 21.9353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_122_2053",
    x1: 9.64275,
    y1: 31.7591,
    x2: 34.5773,
    y2: 31.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#282425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#979696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AFAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_122_2053",
    x1: 33.0671,
    y1: 9.2701,
    x2: 51.786,
    y2: 18.2289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_122_2053",
    x1: 22.4292,
    y1: 21.3076,
    x2: 54.4895,
    y2: 21.3076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#393536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#666364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8B898A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A8A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_122_2053",
    x1: 33.3129,
    y1: 31.4066,
    x2: 55.3222,
    y2: 34.9149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.947f898ca464215d6fff8e511422c24f.svg";
export { ForwardRef as ReactComponent };